let hardware: Hardware[], plans: StripePlan[], shipping: ShippingOption[], orgs: Record<string,Org> = {}

const data: Record<string, Hardware[]|StripePlan[]|ShippingOption[]|Record<string,Org>> = import.meta.env.DEV
    ? import.meta.glob('./*.dev.ts', { eager: true, import: 'default' })
    : import.meta.glob('./*.prod.ts', { eager: true, import: 'default' })

for (const path in data) {
    if (path.includes('hardware')) {
        // @ts-ignore
        hardware = data[path]
    }
    if (path.includes('plans')) {
        // @ts-ignore
        plans = data[path]
    }
    if (path.includes('shipping')) {
        // @ts-ignore
        shipping = data[path]
    }
    if (path.includes('orgs')) {
        // @ts-ignore
        orgs = data[path]
    }
}

export { hardware, plans, shipping, orgs }